<template>
<navbar>
  <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>  <a class="navbar-brand" href="#"></a>
  <ul class="nav navbar-nav d-md-down-none mr-auto">
    <li class="nav-item">
      <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarToggle">&#9776;</a>
    </li>
  </ul>

  <ul class="nav navbar-nav mr-3">
    <li class="nav-item d-md-down-none">
      <b-dropdown :text="realm.name" right class="m-sm-3" :disabled="realms.length == 1">
        <b-dropdown-item v-for="item in realms" :key="item.id" @click="changeRealm(item)">{{item.name}}</b-dropdown-item>
      </b-dropdown>
    </li>
    <dropdown size="nav" class="nav-item">
      <span slot="button">
          <img src="../assets/user-avatar.png" class="img-avatar" alt="avatar" style="border-radius:0px">
      </span>
      <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-right">
        <div class="dropdown-header text-center"><strong>{{firstname}}</strong></div>
        <a class="dropdown-item" href="#" @click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </dropdown>
  </ul>

</navbar>
</template>

<script>
import navbar from './Navbar'
import auth from '../auth'
import {
  dropdown
} from 'vue-strap'

export default {
  name: 'header',
  components: {
    navbar,
    dropdown
  },
  data() {
    return {
      firstname: '',
      realms: [],
      realm: {}
    }
  },
  created() {
    var token = this.$cookie.get('portal_cjp_jwt').split('.')[1]
    var payload = JSON.parse(atob(token))
    this.firstname = payload.firstname
    this.realms = payload.realms
    this.$root.currentRealm = this.realms[0]
    this.realm = this.realms[0]
  },
  methods: {
    changeRealm(item) {
      this.$root.currentRealm = item
      this.realm = item
      this.$router.push('/dashboard')
    },
    sidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    logout() {
      auth.logout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?936e08ba